export const TOAST_TYPE_KEYS = {
  info: "info",
  success: "success",
  error: "error",
  warning: "warning",
} as const;
